import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {getCurrencySymbol} from "@angular/common";
import {Store} from "@ngrx/store";
import {CatalogueSelectors} from "@signature-it/ngx-catalogue/store/selectors";
import {GenericConfig} from '@signature-it/ngx-generic/config';
import {Observable, Subscription} from "rxjs";
import {PriceDTO} from "@signature-it/ngx-catalogue/models";
declare let _: any;

@Component({
    selector: 'price-per-unit',
    templateUrl: './price-per-unit.html',
    styleUrls: ['./price-per-unit.scss'],
    standalone: false
})
export class PricePerUnitComponent implements  OnInit, OnDestroy {

    @Input() pid: number;
    @Input() perUnit: number;
    @Input() unitName: string;

    protected subscriptionsList$: Array<Subscription> = [];
    priceList$: Observable<PriceDTO[]>;
    loadingPriceList$: Observable<boolean>;
    price: PriceDTO;
    unitPrice: number;
    currencySymbol = GenericConfig.currencySymbol == 'symbol-narrow' ? 'symbol-narrow' : 'symbol';

    constructor(protected store$: Store<any>) {
        this.priceList$ = this.store$.select(CatalogueSelectors.getCataloguePriceList);
        this.loadingPriceList$ = this.store$.select(CatalogueSelectors.getLoadingPriceList);
    }

    ngOnInit() {
        let sb1$ = this.priceList$.subscribe((priceList: PriceDTO[]) => {
            if(priceList && priceList.length) {
                this.price = _.filter(Array.from(priceList), {'id': this.pid.toString() })[0];
                if(this.price?.value > 0) {
                    this.unitPrice = this.price.value / this.perUnit
                }
            }
        });
        this.subscriptionsList$.push(sb1$);
    }

    ngOnDestroy() {
        _.each(this.subscriptionsList$, (s) => s.unsubscribe());
    }
}
